import reducers from './reducers';

export { default as initialState } from './initialState';
export { default as SettingsActions } from './actions';

export default reducers;
